import { render, staticRenderFns } from "./settlementBatchNotify.vue?vue&type=template&id=4a775b76&scoped=true"
import script from "./settlementBatchNotify.vue?vue&type=script&lang=ts"
export * from "./settlementBatchNotify.vue?vue&type=script&lang=ts"
import style0 from "./settlementBatchNotify.vue?vue&type=style&index=0&id=4a775b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a775b76",
  null
  
)

export default component.exports